import type {
  AssignLeadCategoryCommand,
  CreateLeadCategoryCommand,
  DemandesTriage,
  UpdateLeadCategoryCommand,
} from '../domain/leadCategory'

/** Erreur stable (`LEAD_CATEGORY_NAME_TAKEN`, …), jamais le message brut du serveur. */
export class DemandesV3Error extends Error {
  constructor(readonly code: string) {
    super(code)
    this.name = 'DemandesV3Error'
  }
}

/** Référentiel de Demandes-V3 : classement des demandes et restauration après suppression. */
export interface DemandesV3Repository {
  getTriage(): Promise<DemandesTriage>
  createCategory(command: CreateLeadCategoryCommand): Promise<void>
  updateCategory(command: UpdateLeadCategoryCommand): Promise<void>
  setCategoryArchived(command: { categoryId: string; archived: boolean }): Promise<void>
  reorderCategories(categoryIds: string[]): Promise<void>
  assignCategory(command: AssignLeadCategoryCommand): Promise<void>
  /** `restore_lead_v1` (permission `lead.restore`) : annule une suppression logique. */
  restoreLead(leadId: string): Promise<void>
}
